<template>
  <div>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <div class="content">
        <div v-if="!resetpsd" style="height: 120px;">
          <div class="flex align-center">
            <div >请输入原密码</div>
            <PassWordDialog
              ref="PassWordInput"
              :psd.sync="passWord"
              class="password-box"
              style="margin-left: 20px;"
            />
            <el-button type="text" @click="forgetPassworld"  style="margin-left: 20px;">忘记密码</el-button>
          </div>
          <p v-if="tip" style="color: red">{{ tip }}</p>
        </div>
        <div v-if="resetpsd">
          <div class="flex align-center">
            <div  style="width: 90px;">设置新密码</div>
            <PassWordDialog
              ref="PassWordInput1"
              :psd.sync="newPassword"
              class="password-box"
            />
          </div>
          <p v-if="tip1" style="color: red">{{ tip1 }}</p>
          <div class="flex align-center" style="margin-top: 20px;">
            <div style="width: 90px;">重新输入密码</div>
            <PassWordDialog
              ref="PassWordInput2"
              :psd.sync="verifyPassword"
              class="password-box"
            />
          </div>
          <p v-if="tip" style="color: red">{{ tip }}</p>
        </div>
      </div>
      <div slot="footer" v-if="resetpsd">
        <el-button size="small" type="primary" @click="resetpsdsubmit">确定</el-button>
        <el-button size="small" @click="handleClose()">取消</el-button>
      </div>
    </el-dialog>
    <!-- 忘记密码弹窗 -->
    <FindPassword ref="findPwdRef"/>
  </div>
</template>

<script>
import md5 from "js-md5";
import { updatePwd, } from "@/api/home.js";
import FindPassword from "@/components/FindPassword.vue"

export default {
  components: {
    PassWordDialog: () => import("./password.vue"),
    FindPassword,
  },
  watch: {
    'passWord.length'(val){
      console.log(val)
      if(val == 6) {
        this.resetpsd = true
      }
    }
  },
  data() {
    return {
      /** 弹窗开关 */
      dialogVisible: false,
      passWord: "",
      tip: "",
      tip1: "",
      /** 重置密码开关 */
      resetpsd: false,
      /** 新密码输入框 */
      newPassword:'',
      /** 确认密码输入框 */
      verifyPassword:'',
    };
  },
  methods: {
    submiteveryThing() {
      let obj = {
        password: md5(this.passWord),
        pwd: md5(this.verifyPassword),
        rePwd: md5(this.newPassword),
      }
      updatePwd(obj)
      .then(res=>{
        if (res.code == 0) {
          this.$YTmsg("修改成功", "success");
          this.handleClose()
        } else {
          this.$YTmsg(res.message, "error");
          this.handleClose()    
        }
      })
    },
    /** 忘记密码按钮 */
    forgetPassworld() {
      this.handleClose();
      this.$refs.findPwdRef.openDialog();
    },
    /** 确定按钮 */
    resetpsdsubmit() {
      if (this.newPassword.length < 6) {
        return this.tip1 = '请输入六位密码'
      } else {
        this.tip1 = ''
      }
      if (this.verifyPassword.length < 6) {
        return this.tip = '请输入六位密码'
      } else {
        this.tip = ''
      }
      if (this.verifyPassword!==this.newPassword) {
        return this.tip = '两次密码输入不一致'
      } else {
        this.tip = ''
      }
      // 调用接口
      this.submiteveryThing()
    },
    // 关闭重置数据
    clearpassworld() {
      this.resetpsd = false
      this.passWord = ''
      this.tip = ''
      this.tip1 = ''
      this.$refs.PassWordInput?.resetMsg();
      this.$refs.PassWordInput1?.resetMsg();
      this.$refs.PassWordInput2?.resetMsg();
    },
    handleClose() {
      this.clearpassworld();
      this.dialogVisible = false
    },
    openDialog(){
      this.dialogVisible = true
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  width: 330px;
}
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 180px;
  .right {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
  }
}
</style>